export const profileNameStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: 0,
		minWidth: 0
	},
	name: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'nowrap',
		gap: 1,
		alignItems: 'center',
		minWidth: 0
	},
	editButtonWrapper: {
		display: 'inline-flex',
		alignItems: 'center'
	},
	editButtonCustomSx: {
		paddingY: 0.25
	},

	editIconButtonCustomSx: {
		padding: 0.25,
		marginTop: '-2px'
	},
	editHover: {
		'@media (hover: hover)': {
			'&:hover [data-edit-icon], &:focus-within [data-edit-icon]': {
				opacity: 1,
				pointerEvents: 'auto'
			}
		}
	},
	nameSpanMargin: (withDegrees: boolean | undefined, inline: boolean) => ({
		mr: withDegrees || inline ? 0 : 1
	}),
	degrees: (inline: boolean, withLink: boolean) => ({
		color: withLink ? 'info.main' : 'text.secondary',
		fontWeight: 400,
		mr: inline ? 0 : 1
	}),
	chips: {
		display: 'inline-flex',
		flexWrap: 'wrap',
		gap: 1,
		alignItems: 'center',
		verticalAlign: 'middle',
		fontWeight: 400,
		flexShrink: 0
	},
	profileLink: {
		flex: '0 0 auto',
		fontWeight: 700,
		height: 32
	},
	highlightMark: {
		backgroundColor: 'var(--mui-palette-highlight-main)',
		color: 'inherit',
		fontWeight: 400,
		borderRadius: '4px',
		padding: '0 2px',
		margin: '0 -2px'
	}
};
